;(function (YUI, $) {
  'use strict'

  var BOUNDING_BOX = 'boundingBox'

  YUI.add('ent-custom-form-validator', function (Y) {
    function fixNativeExtractRulesFrom () {
      Y.FormValidator.prototype._extractRulesFromMarkup = function (rules) {
        var instance = this
        var domBoundingBox = instance.get(BOUNDING_BOX).getDOM()
        var elements = domBoundingBox.elements
        var regex = Y.DOM._getRegExp('(field-)\\w+', 'g')
        var i
        var length
        var ruleNameMatch = []

        function ruleMatcher (m1, m2) {
          ruleNameMatch.push(m1.replace(m2, ''))
        }

        for (i = 0, length = elements.length; i < length; i++) {
          var el = elements[i]
          var isVisible = (el.offsetParent !== null)
          var fieldName = el.name

          if (isVisible) {
            el.className.replace(regex, ruleMatcher)
            if (ruleNameMatch.length) {
              var fieldRules = rules[fieldName]
              var j
              var ruleNameLength

              if (!fieldRules) {
                fieldRules = {}
                rules[fieldName] = fieldRules
              }

              for (j = 0, ruleNameLength = ruleNameMatch.length; j < ruleNameLength; j++) {
                var rule = ruleNameMatch[j]

                if (!(rule in fieldRules)) {
                  fieldRules[rule] = el.getAttribute(rule) || true
                }
              }
              ruleNameMatch.length = 0
            }
          }
        }
        instance._rulesAlreadyExtracted = true
      }
    }

    function fixCustonValidatorCall () {
      Y.FormValidator.prototype.validatable = function (field) {
        var instance = this
        var validatable = false
        var fieldRules = instance.get('rules')[field.get('name')]

        if (fieldRules && $(field.getDOM()).is(':visible')) {
          validatable = fieldRules.custom ||
                      instance.normalizeRuleValue(fieldRules.required, field) ||
                      Y.config.FormValidator.RULES.hasValue.apply(instance, [field.val(), field])
        }

        return !!validatable
      }
    }

    function addStringMessages () {
      Y.FormValidator.ATTRS.strings.valueFn = function () {
        return {
          'default': 'Por favor, conserte este campo.',
          'acceptFiles': 'Por favor, insira um valor com uma extensão válida ({0}).',
          'alpha': 'Por favor, insira somente caracteres alfa.',
          'alphanum': 'Por favor, insira somente caracteres alfanuméricos.',
          'date': 'Por favor, insira uma data válida.',
          'digits': 'Por favor, insira somente caracteres numéricos.',
          'email': 'Por favor, insira um endereço de e-mail válido.',
          'equalTo': 'Por favor, insira o mesmo valor novamente.',
          'bincode': 'Por favor, insira um Bincode válido.',
          'iri': 'Por favor, insira uma IRI válida.',
          'max': 'Por favor, insira um valor menor ou igual à {0}.',
          'maxFiles': 'Por favor, insira não mais que {0} arquivos.',
          'minFiles': 'Por favor, insira não menos que {0} arquivos.',
          'maxLength': 'Por favor, insira não mais que {0} caracteres.',
          'maxYersOld': 'Você deve ter no máximo {0} anos.',
          'min': 'Por favor, insira um valor maior ou igual à {0}.',
          'minLength': 'Por favor, insira pelo menos {0} caracteres.',
          'minYersOld': 'Você deve ter no mínimo {0} anos.',
          'number': 'Por favor, insira um número válido.',
          'range': 'Por favor, insira um valor entre {0} e {1}.',
          'rangeLength': 'Por favor, insira um valor de tamanho entre {0} e {1} caracteres.',
          'required': 'Este campo é obrigatório.',
          'whenVisibleRequired': 'Este campo é obrigatório.',
          'conditionalFieldRequired': 'Este campo é obrigatório.',
          'url': 'Por favor, insira uma URL válida.',
          'password': 'A senha precisa ter 8 caracteres numéricos e não pode ser uma sequência de números, nem pode repetir o mesmo número cinco vezes seguidas.',
          'dateHourRange': 'Hora inválida.',
          'customBirthDate': 'Data aniversário inválida.',
          'cpf': 'Por favor, insira um CPF válido.',
          'zipCode': 'Por favor, insira um CEP válido.',
          'hour': 'Por favor, entre um valor entre 00:00 e 23:59.',
          'letters': 'Por favor, insira somente letras e espaços.',
          'cnpj': 'Por favor, insira um CNPJ válido.',
          'dateWithMask': 'Por favor, insira uma data válida.',
          'lessThanCurrentDate': 'Por favor, insira uma data válida.',
          'selectMultipleLimit': 'Por favor, selecione no máximo {0} elementos.',
          'fullName': 'Por favor, insira o nome completo.',
          'hostDomain': 'E-mail informado não pode ser do domínio Unifor.',
          'fileSize': 'O tamanho do arquivo não pode exceder {0} MB',
          'requiredPieceSet': 'Este campo é obrigatório.'
        }
      }
    }

    function addUpdateFields () {
      Y.FormValidator.prototype.updateFields = function () {
        this.updateFormRules()

        $('.field-required, .field-whenVisibleRequired').each(function (i, element) {
          getLabelOf(element).addClass('required')
        })

        $('.field-conditionalFieldRequired').each(function (i, element) {
          var $element = $(element)
          var fieldLabel = getLabelOf($element)
          if (getConditional($element)) {
            fieldLabel.addClass('required')
          } else {
            fieldLabel.removeClass('required')
          }
        })

        updateRequiredPieceSet.call(this)
      }

      function updateRequiredPieceSet () {
        var instance = this,
          $requiredPieceSet = $('.field-requiredPieceSet'),
          nameSets = []

        $requiredPieceSet.each(function () {
          var $piece = $(this),
            nameSet = $piece.attr('requiredPieceSet')

          if (nameSets.indexOf(nameSet) === -1) {
            nameSets.push(nameSet)
          }
        })

        $requiredPieceSet.off('.requiredPiece').on('blur.requiredPiece change.requiredPiece', function () {
          var nameSet = $(this).attr('requiredPieceSet'),
            $members = getMembers(nameSet),
            isRequired = isRequiredSet($members)

          if (!isRequired) {
            setTimeout(function () {
              resetMembers($members)
            }, 100)
          }
        })

        nameSets.map(function (nameSet) {
          var $members = getMembers(nameSet),
            isRequired = isRequiredSet($members),
            $labels = $()

          $members.each(function () {
            $labels.push(getLabelOf(this))
          })

          if (isRequired) {
            $labels.each(function () {
              $(this).addClass('required')
            })
          } else {
            $labels.each(function () {
              $(this).removeClass('required')
            })

            resetMembers($members)
          }
        })

        function resetMembers ($members) {
          $members.each(function () {
            instance.validateField(this.name)
          })
        }

        function getMembers (nameSet) {
          return $requiredPieceSet.filter('[requiredPieceSet=' + nameSet + ']')
        }

        function isRequiredSet ($members) {
          var fieldsRule = $members.filter(function () {
            return $(this).val().length === 0
          })

          return fieldsRule.length !== $members.length
        }
      }

      function getLabelOf (field) {
        return $($(field).closest('.form-group')).find('label')
      }
    }

    function addUpdateFormRulesMethod () {
      Y.FormValidator.prototype.updateFormRules = function () {
        this._rulesAlreadyExtracted = false
      }
    }

    function addWhenVisibleRequiredValidator () {
      Y.config.FormValidator.RULES.whenVisibleRequired = function (val, node) {
        var isVisible = $(node._node || node).is(':visible')
        if (!isVisible) {
          return true
        } else {
          return !!val
        }
      }
    }

    function getConditional ($element) {
      var declaredConditional = $element.data('conditional-field') || ''
      var conditionals = declaredConditional.split(';')
      var resultOfConditionals = false

      conditionals.forEach(function (conditional) {
        var splitedConditional = null
        if (conditional.indexOf('===') >= 0) {
          splitedConditional = conditional.split('===')
          resultOfConditionals |= $(splitedConditional[0]).val() === splitedConditional[1]
        } else if (conditional.indexOf('!==') >= 0) {
          splitedConditional = conditional.split('!==')
          resultOfConditionals |= $(splitedConditional[0]).val() !== splitedConditional[1]
        }

        if (resultOfConditionals) {
          return true
        }
      })

      return resultOfConditionals
    }

    function addConditionalFieldRequired () {
      Y.config.FormValidator.RULES.conditionalFieldRequired = function (val, node) {
        var $element = $(node._node || node)
        if (getConditional($element)) {
          return !!val
        }
        return true
      }
    }

    function addMaxFiles () {
      Y.config.FormValidator.RULES.maxFiles = function (val, node, maxFiles) {
        return maxFiles >= node._node.files.length
      }
    }

    function addMinFiles () {
      Y.config.FormValidator.RULES.minFiles = function (val, node, minFiles) {
        return minFiles <= node._node.files.length
      }
    }

    function addMinYersOld () {
      Y.config.FormValidator.RULES.minYersOld = function (val, node, minYersOld) {
        var splitedDate = val.split('/')
        var informedDate = new Date(splitedDate[2], splitedDate[1] - 1, splitedDate[0]).getTime()
        var currentDate = new Date()
        var limitYearsOldTime = new Date(currentDate.getFullYear() - minYersOld, currentDate.getMonth(), currentDate.getDate()).getTime()
        return informedDate <= limitYearsOldTime
      }
    }

    function addMaxYersOld () {
      Y.config.FormValidator.RULES.maxYersOld = function (val, node, maxYersOld) {
        var splitedDate = val.split('/')
        var informedDate = new Date(splitedDate[2], splitedDate[1] - 1, splitedDate[0] - 1).getTime()
        var currentDate = new Date()
        var limitYearsOldTime = new Date(currentDate.getFullYear() - maxYersOld, currentDate.getMonth(), currentDate.getDate()).getTime()
        return informedDate >= limitYearsOldTime
      }
    }

    function addDateWithMask () {
      Y.config.FormValidator.RULES.dateWithMask = function (val, node, maskRule) {
        var splitedDate = val.split('/')
        var dateFormat = Y.Lang.isString(maskRule) ? maskRule : 'dd/mm/yyyy'
        var maskElements = dateFormat.split('/')
        var maskSize = maskElements.length

        if (splitedDate.length !== maskSize) {
          return false
        }

        return maskElements.filter(function (mask, index) {
          var dateItem = splitedDate[index]
          switch (mask.toLowerCase()[0]) {
            case 'y':
              return checkYear(dateItem, mask)
            case 'm':
              return checkMonth(dateItem)
            case 'd':
              return checkDay(dateItem)
          }
        }).length === maskSize

        function checkDay (day) {
          return day > 0 && day <= 31
        }

        function checkMonth (month) {
          return month > 0 && month <= 12
        }

        function checkYear (year, mask) {
          if (mask) {
            if (year.length !== mask.length) return false
          }
          return (year > 0)
        }
      }
    }

    function addLessThanCurrentDate () {
      Y.config.FormValidator.RULES.lessThanCurrentDate = function (val, node) {
        var splitedDate = val.split('/')
        var informedDate = new Date(splitedDate[2], splitedDate[1] - 1, splitedDate[0])
        var currentDate = new Date()
        currentDate.setHours(0, 0, 0, 0)
        return informedDate.getTime() < currentDate.getTime()
      }
    }

    function addSelectMultipleLimit () {
      Y.config.FormValidator.RULES.selectMultipleLimit = function (val, node, limit) {
        var $element = $(node._node || node)
        var elements = $element.val() || []
        return elements.length <= limit
      }
    }

    function addCpf () {
      Y.config.FormValidator.RULES.cpf = function (val) {
        if (!val) return true

        var sum
        var rest
        var i = 0
        sum = 0
        val = val.replace(/[.-]/g, '')
        if (val.length < 11) { return false }

        // equal numbers
        var arrCpf = val.split('')
        var first = arrCpf.shift()
        var equalNumbersLength = arrCpf.filter(function (n) {
          return n === first
        }).length

        if (equalNumbersLength === arrCpf.length) {
          return false
        }

        if (val === '00000000000') {
          return false
        }

        for (i = 1; i <= 9; i++) {
          sum = sum + parseInt(val.substring(i - 1, i)) * (11 - i)
        }

        rest = (sum * 10) % 11

        if ((rest === 10) || (rest === 11)) {
          rest = 0
        }

        if (rest !== parseInt(val.substring(9, 10))) {
          return false
        }
        sum = 0

        for (i = 1; i <= 10; i++) {
          sum = sum + parseInt(val.substring(i - 1, i)) * (12 - i)
        }

        rest = (sum * 10) % 11

        if ((rest === 10) || (rest === 11)) {
          rest = 0
        }

        if (rest !== parseInt(val.substring(10, 11))) {
          return false
        }
        return true
      }
    }

    function isInteger (num) {
      var numCopy = parseFloat(num)
      return !isNaN(numCopy) && numCopy == numCopy.toFixed()
    }

    function hasSequencePattern (val) {
      var sequencePattern = '01234567890987654321' // to match circular sequence as well.
      return sequencePattern.indexOf(val) == -1
    }

    function hasRepeatableSequence (val) {
      return /(.)\1\1\1\1/.test(val)
    }

    function addPassword () {
      Y.config.FormValidator.RULES.password = function (val, node, password) {
        /*
        * 8 numeric characters.
        * Password can not be a sequence of numbers, nor can it repeat the same number five times.
        */
        if ((!hasRepeatableSequence(val) && hasSequencePattern(val) && isInteger(val)) || !val) {
          return true
        }
        return false
      }
    }

    function addFullName () {
      Y.config.FormValidator.RULES.fullName = function (val, node, ruleValue) {
        var value = val.trim()

        if (value.length !== 0) {
          var namesMatched = value.match(/\s/gi)
          return namesMatched && namesMatched.length >= 1
        }

        return true
      }
    }

    function addDomain () {
      Y.config.FormValidator.RULES.hostDomain = function (val, node, ruleValue) {
        var validExcept = [
          'unifor.'
        ]

        var mailDomain = val.match(/@.*/gi)

        if (mailDomain && mailDomain[0].indexOf(validExcept) >= 0) {
          return false
        }

        return true
      }
    }

    function addFileSize () {
      Y.config.FormValidator.RULES.fileSize = function (val, fieldNode, ruleMaxSize) {
        if (Y.Lang.isString(ruleMaxSize) && !isNaN(ruleMaxSize)) {
          var files = fieldNode.get('files'),
            maxSize = parseFloat(ruleMaxSize) * 1024 * 1024

          if (files.size() > 0) {
            var file = files.shift()

            if (file.size < maxSize) {
              return true
            }

            return false
          }
        }

        return true
      }
    }

    function addRequiredPieceSet () {
      Y.config.FormValidator.RULES.requiredPieceSet = function (val, fieldNode, nameSet) {
        var $members = $('[requiredPieceSet=' + nameSet + ']')

        if ($members.length > 0) {
          var fieldsRule = $members.filter(function () {
              return $(this).val().length === 0
            }),
            $labels = $(),
            isRequiredSet = fieldsRule.length !== $members.length

          $members.each(function () {
            $labels.push($(this).closest('.form-group').find('label'))
          })

          if (isRequiredSet) {
            $labels.each(function () {
              $(this).addClass('required')
            })
            return val.length !== 0
          }

          $labels.each(function () {
            $(this).removeClass('required')
          })

          return true
        }

        return true
      }
    }

    function overwriteDigitsValidation () {
      var digitsValidation = Y.config.FormValidator.RULES.digits
      Y.config.FormValidator.RULES.digits = function (val) {
        if (val.length === 0) return true

        return digitsValidation(val)
      }
    }

    function init () {
      fixNativeExtractRulesFrom()
      fixCustonValidatorCall()
      addUpdateFields()
      addUpdateFormRulesMethod()
      addWhenVisibleRequiredValidator()
      addStringMessages()
      addConditionalFieldRequired()
      addMaxFiles()
      addMinFiles()
      addMinYersOld()
      addMaxYersOld()
      addDateWithMask()
      addLessThanCurrentDate()
      addSelectMultipleLimit()
      addCpf()
      addPassword()
      addFullName()
      addDomain()
      addFileSize()
      addRequiredPieceSet()

      overwriteDigitsValidation()
    }

    init()
  }, '0.0.1', {
    requires: [
      'aui-form-validator'
    ]
  })
})(window.YUI, window.$)
